var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"text-center",attrs:{"href":`${_vm.origin}/app/objectives/${_vm.objectiveId}/keyResults/${_vm.keyResultId}/checkin`}},[_c('i',{staticClass:"fa fa-calendar-check-o fa-lg"}),_c('p',{staticClass:"m-0"},[_c('small',[_vm._v("Check-in")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }